module.exports = __webpack_public_path__ + "static/media/jack_of_hearts.02d4f21b.svg";